import styled from 'styled-components';
import * as colors from 'components/common/colorConstants';
import { HeaderText } from 'components/common/fontElements';

export const FlexCenterWrapper = styled.div`
  display: flex;
  height: auto !important;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: auto !important;
  margin: 0px auto;
  padding: 30px 0px 130px;
  width: 253px;
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
  opacity: 0%;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const TextContainer = styled.div`
  margin-bottom: 20px;
`;

export const Title = styled(HeaderText)`
  text-align: center;
  margin-bottom: 15px;
`;

export const SubTitle = styled.p`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 16px;
  text-align: center;
  color: ${colors.darkGray1};
  margin-bottom: 15px;
`;
